import { useState, useEffect } from "react";
import { visionURL } from "../config/environment";
import Jsona from "jsona";
import JsonApiService from "../services/jsonapiService";

const dataFormatter = new Jsona();

const courseVersionsApiService = async courseId =>
  new JsonApiService("versions", {
    baseUrl: `${visionURL}/admin_console/api/content/courses/${courseId}`,
    credentials: "include"
  });

export const useCourseVersions = (parentTrainingObjectId, status, include) => {
  const [loading, setLoading] = useState(false);
  const [courseVersions, setCourseVersions] = useState([]);

  useEffect(() => {
    const fetchCourseVersions = async () => {
      if (parentTrainingObjectId) {
        setLoading(true);
        const service = await courseVersionsApiService(parentTrainingObjectId);
        const response = await service
          .include(include)
          .where({ status: status })
          .all()
          .then(response => response.json());
        setLoading(false);
        setCourseVersions(dataFormatter.deserialize(response));
      }
    };

    fetchCourseVersions();
  }, [parentTrainingObjectId]);

  return {
    courseVersions,
    loading
  };
};
